// extracted by mini-css-extract-plugin
export default {"NPSSurvey":"KijzY","title":"X1v3C","description":"QIcP7","participateButton":"VEP1H","closeButton":"xgdsH","content":"SxvLD"};